<template>
<select>
    <slot></slot>
</select>
</template>

<script>
export default {
    
}
</script>